import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container } from "@mui/material";
import { notification } from "../../utils/Notifications";
import { getDeliveryMan } from "../../api/userApi";
import DeliverersDetailsHeader from "../../components/Deliverers/DeliverersDetailsHeader";
import Title from "../../components/SharedComponents/Title";
import useLogout from "../../hooks/auth/authHook.js";
import styles from "./deliverersDetailsStyles.js";
import { usePermissions } from "../../hooks/permissions/usePermissions.js";

const DeliverersDetails = () => {
  const [logout] = useLogout();

  const { id } = useParams();

  const [deliveryMan, setDeliveryMan] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const { hasAllPermissions } = usePermissions();

  const getDeliverersDetails = () => {

    if (!hasAllPermissions(["cut_vw", "cut_ovw"])) return;

    setIsLoading(true);
    getDeliveryMan(id)
      .then((response) => {
        if (response.data.status_Code === 200) {
          setDeliveryMan(response.data.info_dealer);
        } else if (response.data.status_Code === 401) {
          notification({
            text: "Sesión expirada. Por favor, inicia sesión nuevamente.",
            type: "error",
          });
          logout();
        } else {
          notification({
            text: "Error al obtener datos del repartidor",
            type: "error",
          });
        }
      })
      .catch((error) => {
        notification({
          text: "Error de conexión, revisa tu conexión a internet",
          type: "error",
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  useEffect(() => {
    getDeliverersDetails();
  }, [id]);

  return (
    <Container
      style={styles.mainContainer}
    >
      <Title title="Detalles de repartidor" />
      <DeliverersDetailsHeader
        deliveryMan={deliveryMan}
        isLoading={isLoading}
        getDeliverersDetails={getDeliverersDetails}
      />
    </Container>
  );
};

export default DeliverersDetails;
